<template>
    <v-container fluid>
        <v-row class="ma-0 px-4" justify="space-between" no-gutters>
            <v-col xs="12" md="6" lg="4" class="pa-2">
                <GraficoCircular
                    title="Contratos elaborados"
                    :items="itemsContratosElaborados"
                    tipo="contratos"
                />
            </v-col>
            <v-col xs="12" md="6" lg="4" class="pa-2">
                <GraficoCircular
                    title="Empleados activos"
                    :items="itemsEmpleadosActivos"
                    tipo="activos"
                />
            </v-col>
            <v-col xs="12" md="6" lg="4" class="pa-2">
                <GraficoCircular
                    title="Empleados inactivos"
                    :items="itemsEmpleadosInactivos"
                    tipo="inactivos"
                />
            </v-col>
        </v-row>
        <!--Contadores-->
        <v-row  class="ma-0 px-4">
            <v-col xs="12" md="6" clas="pa-2">
                <Contadores
                    title="Contratos por estatus"
                    imagen="/static/modal/contrato.png"
                    :data="itemsContratosStatus"
                />
            </v-col>
            <v-col xs="12" md="6" clas="pa-2">
                <Contadores
                    title="Contratos por tipo"
                    imagen="/static/icon/nueva_carpeta.png"
                    :data="itemsContratosTipo"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import GraficoCircular from "@/components/dashboardContratos/GraficoCircular.vue";
import Contadores from '@/components/dashboardContratos/Contadores.vue';
    export default {
        components:{
            GraficoCircular,
            Contadores
        },
        props:{
            itemsContratosElaborados:{
                type:Array,
                required:true
            },
            itemsEmpleadosActivos:{
                type:Array,
                required:true
            },
            itemsEmpleadosInactivos:{
                type:Array,
                required:true
            },
            itemsContratosStatus:{
                type:Array,
                required:true
            },
            itemsContratosTipo:{
                type:Array,
                required:true
            }
        },
    }
</script>

<style scoped >

</style>